<template>
  <v-row class="primary spa-tile">
    <v-card flat tile class="white pb-4" width="100%" min-height="150">
      <v-card-title color="primary">Обратная связь</v-card-title>
      <v-card-subtitle color="primary"
        ><p>ТОО «РИП-газ»</p>
        Атырауская область, г.Кульсары, Промзона</v-card-subtitle
      >

      <v-card-actions>
        <v-btn color="primary" :href="'tel:' + contacts.phone" text>
          <v-icon size="24px">mdi-phone</v-icon>
          {{ contacts.phone }}
        </v-btn>

        <v-btn color="primary" :href="'mailto:' + contacts.email" text>
          <v-icon size="24px">mdi-email</v-icon>
          {{ contacts.email }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card flat tile class="white" width="100%" height="450">
      <yandex-map
        @map-was-initialized="catchMap"
        :coords="[47.347133, 52.150402]"
        zoom="9"
        style="width: 100%; height: 100%;"
        :controls="controls"
        map-type="map"
      >
        <ymap-marker
          marker-type="placemark"
          marker-id="mahambet"
          :coords="[47.250128, 51.556015]"
          hint-content="Станция Махамбет"
          :balloon="{ header: textMahambet, body: null, footer: null }"
          :icon="{ color: 'green', glyph: 'railway' }"
        ></ymap-marker>

        <ymap-marker
          marker-type="placemark"
          marker-id="dossor"
          :coords="[47.546745, 52.965161]"
          hint-content="Станция Доссор"
          :balloon="{ header: textDossor, body: null, footer: null }"
          :icon="{ color: 'green', glyph: 'railway' }"
        ></ymap-marker>
      </yandex-map>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: "contactblock",
  props: ["contacts"],
  data: () => ({
    //controls: ["typeSelector", "rulerControl", "zoomControl", "routeButtonControl"],
    controls: ["typeSelector", "zoomControl", "geolocationControl"],
    textDossor: "23,5 км путей по ст. Доссор",
    textMahambet: "7,3 км путей по ст. Махамбет"
  }),
  methods: {
    catchMap() {
      console.log("map loaded");
    }
  }
};
</script>

<style scoped>
.spa-tile {
}

.map-card {
  height: 80% !important;
  width: 100% !important;
}

.map-text {
  height: 20% !important;
  width: 100% !important;
}

button.map-contact-link {
  color: #000000 !important;
}
</style>
